import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import ResponsiveVideo from './components/ResponsiveVideo';
import VideoPlayer from './components/VideoPlayer';
import ShowHideModule from './components/ShowHideModule';
import CalculateReadingTime from './components/CalculateReadingTime';
import TableOfContent from './components/TableOfContent';
import InsightsFilter from './components/InsightsFilter';
import Menu from './components/Menu';


export class Alfred {
	constructor() {
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		new Menu();
		new ShowHideModule();
		new CalculateReadingTime();
		new TableOfContent();
		ResponsiveVideo.init();
		VideoPlayer.init();


		const $insightsfilter = document.querySelector('[data-insightsfilter-container]');
		if ($insightsfilter) {
			new InsightsFilter($insightsfilter);
		}

		// change label Cookie Consent
		document.getElementById("functional").nextElementSibling.innerHTML = "Functional";
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();